import { Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { Scrollbars } from 'react-custom-scrollbars'
import FilterResults from 'react-filter-search'
import { useTranslation } from 'react-i18next'
import FormIcon from '../../Form/FormIcon'
import InputCheckbox from '../../Form/input/InputCheckbox'
import SlidingForm from '../../Form/SlidingForm'
import { PLATFORM_ID_COOKIE } from '../../../constants/cookies'
import { URL as API_BASE_URL } from '../../../constants/url'
import { addPdPContactWithId } from '../../../containers/DataContainer'
import api from '../../../utils/Requester'
import Form from '../../Form/Form'
import FormButtonIcon from '../../Form/FormButtonIcon'
import InputSearch from '../../Form/input/InputSearch'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
	scrollbars: {
		height: '63vh',
	},
	inputSearch: {
		margin: 10,
		width: '90%',
	},
	validateButton: {
		marginLeft: 0,
	},
	tooltip: {
		maxWidth: 'none',
	},
}))

function AddContactListForm({ open, close, data }) {
	const classes = useStyles()
	const [value, setValue] = useState('')
	const [cookies] = useCookies()
	const { enqueueSnackbar } = useSnackbar()
	const { t } = useTranslation(['contacts'])
	const [contactLists, setContactLists] = useState([])

	const search = (event) => {
		setValue(event.target.value)
	}

	const getLists = () => {
		const platformId = cookies[PLATFORM_ID_COOKIE]
		api.get(`${API_BASE_URL}platform/${platformId}/contact-lists`).then((res) => {
			if (!res.problem && Array.isArray(res.data)) {
				setContactLists(res.data)
			}
		})
	}

	const onSubmit = (values) => {
		const selectedLists = contactLists.filter((list) => values['list-' + list.lctId])
		if (!selectedLists.length) {
			setValue('')
			close()
			return
		}
		const platformId = cookies[PLATFORM_ID_COOKIE]
		const userIds = selectedLists.flatMap((list) => (list.users || []).map((u) => u.utlId))
		if (!userIds.length) {
			setValue('')
			close()
			return
		}
		addPdPContactWithId(platformId, userIds, data.pdpId, data.revisionNumber, (res, error) => {
			if (error) {
				enqueueSnackbar(t('error'), { variant: 'error' })
				return
			}
			data.setNeedRefresh(true)
			if (data.setRefreshChevrons) data.setRefreshChevrons(!data.refreshChevrons)
			enqueueSnackbar(t('contactAddedToPdP'), { variant: 'info' })
		})
		setValue('')
		close()
	}

	useEffect(() => {
		if (open) getLists()
	}, [open])

	return (
		<SlidingForm
			direction="vertical"
			open={open}
			title={t('contact_lists')}
			iconAttachement={
				<FormIcon
					icon="clear"
					onClick={() => {
						setValue('')
						close()
					}}
				/>
			}
			onClose={() => {
				setValue('')
				close()
			}}
		>
			<Form onSubmit={onSubmit} initialValues={{}}>
				<InputSearch
					name="search"
					label={t('search')}
					onChange={search}
					classes={{ root: classes.inputSearch }}
				/>
				<div className={classes.scrollbars}>
					<Scrollbars>
						<FilterResults
							value={value}
							data={contactLists}
							renderResults={(results) => (
								<div>
									{results.map((list) => (
										<Tooltip
											key={list.lctId}
											placement="left"
											classes={{ tooltip: classes.tooltip }}
											title={
												<div>
													{(list.users || []).map((u) => (
														<div key={u.utlId} style={{ whiteSpace: 'nowrap' }}>{`${u.utlNom || ''} ${u.utlPrenom || ''} <${u.utlEmail}>`}</div>
													))}
													{!(list.users && list.users.length) && 'Aucun contact'}
												</div>
											}
										>
											<div>
												<InputCheckbox
													name={'list-' + list.lctId}
													label={list.lctNom}
													value={list.lctId}
												/>
											</div>
										</Tooltip>
									))}
								</div>
							)}
						/>
					</Scrollbars>
				</div>
				<div>
					<FormButtonIcon classes={{ root: classes.validateButton }} type="submit" />
				</div>
			</Form>
		</SlidingForm>
	)
}

AddContactListForm.propTypes = {
	open: PropTypes.bool,
	close: PropTypes.func,
	data: PropTypes.object,
}

export default AddContactListForm
